import { render } from "./FileDefault.vue?vue&type=template&id=a73e6b4a"
import script from "./FileDefault.vue?vue&type=script&lang=js"
export * from "./FileDefault.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__